import EllipsisHoverToggle from '@/components/_common/EllipsisHoverToggle';
import StatusTag from '@/components/_common/StatusTag';
import { AccountPayableListGroupingResponse } from '@/core/domain/financial/AccountPayable/AccountPayable.types';
import { quantityFormatter } from '@/utils/number';
import { getTableScrollX } from '@/utils/table';
import { Table } from 'antd';
import Modal, { ModalProps } from 'antd/lib/modal/Modal';
import { ColumnsType } from 'antd/lib/table';
import moment from 'moment';

interface Props extends Omit<ModalProps, 'onCancel'> {
  onCancel: VoidFunction;
  listGroupingData?: AccountPayableListGroupingResponse[];
}

export default function AccountPayableListGroupingModal({
  listGroupingData,
  ...props
}: Props) {
  const columns: ColumnsType<AccountPayableListGroupingResponse> = [
    {
      title: 'Código',
      dataIndex: 'code',
      key: 'code',
      width: 80,
      ellipsis: true,
    },
    {
      title: 'Empresa',
      dataIndex: 'companyName',
      key: 'companyName',
      width: 180,
      ellipsis: true,
    },
    {
      title: 'Credor',
      dataIndex: 'creditor',
      key: 'creditor',
      render: (value) => <EllipsisHoverToggle>{value}</EllipsisHoverToggle>,
      width: 160,
      ellipsis: true,
    },
    {
      title: 'Descrição',
      dataIndex: 'description',
      key: 'description',
      render: (value) => <EllipsisHoverToggle>{value}</EllipsisHoverToggle>,
      width: 220,
      ellipsis: true,
    },
    {
      title: 'Vencimento',
      dataIndex: 'dueDate',
      key: 'dueDate',
      render: (value) => moment(value).format('DD/MM/YYYY'),
      width: 90,
      align: 'center',
      ellipsis: true,
    },
    {
      title: 'Situação',
      dataIndex: 'situation',
      key: 'situation',
      render: () => <StatusTag label="Agrupado" color="yellow" />,
      width: 100,
      align: 'center',
      ellipsis: true,
    },
    {
      title: 'Valor (R$)',
      dataIndex: 'installmentValue',
      key: 'installmentValue',
      render: (value: number) => `R$ ${quantityFormatter(value)}`,
      align: 'right',
      width: 120,
      ellipsis: true,
    },
  ];

  return (
    <Modal title="Contas Agrupadas" footer={null} width={1000} {...props}>
      <Table
        dataSource={listGroupingData}
        columns={columns}
        scroll={{ x: getTableScrollX(columns) }}
        pagination={false}
      />
    </Modal>
  );
}
